import { Box, Grid, styled } from "@mui/material";

import ProfileStatue from "./Component/ProfileStatue";
import { useSelector } from "react-redux";

export function AccessUsers() {
  const profile = useSelector((state) => state.user?.user?.data);

  return (
    <BoxAccessUsers>
      <Grid container>
        <Grid item xs={12} className={"wrap-profile"}>
          <ProfileStatue
            label="اجازه سفارش"
            condition={profile?.isTradeAllow}
            text={profile?.isTradeAllow ? "دارد" : "ندارد"}
          />

          <ProfileStatue
            label="اجازه مارجین"
            condition={profile?.isOrderAllow}
            text={profile?.isOrderAllow ? "دارد" : "ندارد"}
          />

          <ProfileStatue
            label="پرداخت کارمزد با USDT "
            condition={profile?.isMarginAllow}
            text={profile?.isMarginAllow ? "دارد" : "ندارد"}
          />

          <ProfileStatue
            label="حساب کاربری"
            condition={profile?.isUserEnable}
            text={profile?.isUserEnable ? "فعال" : "غیرفعال"}
          />

          <ProfileStatue
            label="احراز هویت"
            condition={profile?.isUserAuthentication}
            text={profile?.isUserAuthentication ? "تایید " : "تایید نشده"}
          />

          <ProfileStatue
            label=" اجازه برداشت"
            condition={profile?.isWithdrawAllow}
            text={profile?.isWithdrawAllow ? "تایید " : "تایید نشده"}
          />

          <ProfileStatue
            label=" اجاره مبادله"
            condition={profile?.isPaymentFeeWithUSDT}
            text={profile?.isPaymentFeeWithUSDT ? "تایید " : "تایید نشده"}
          />
        </Grid>
      </Grid>
    </BoxAccessUsers>
  );
}
const BoxAccessUsers = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(2),
}));

export default AccessUsers;
